import LayoutDashboard from "components/LayoutDashboard";
import TransitionalRegion from "components/TransitionalRegion";
import { lazy, Suspense } from "react";
import { Navigate, Route } from "react-router-dom";

const SemanticSearch = lazy(() => import("features/SemanticSearch"));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Suspense fallback={<TransitionalRegion noResultsText={<></>} />}>
    {children}
  </Suspense>
);

/** Pure ACCOUNT_SEARCHER: /search only (Search tab). Everything else 404s. */
const AccountSearcherRoutes = (
  <Route
    element={
      <SuspenseWrapper>
        <LayoutDashboard />
      </SuspenseWrapper>
    }
  >
    <Route index element={<Navigate to="/search" replace />} />
    <Route path="search" element={<SemanticSearch />} />
  </Route>
);

export default AccountSearcherRoutes;
